import { Serializer } from '@lib/store';
import { bookingSearchInitialState } from './booking-search.reducer';
import { BookingSearchState } from './booking-search.state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bookingSearchStorageDeserializer = (rawObject: any) => {
  return {
    ...bookingSearchInitialState,
    model: rawObject && rawObject.model ? rawObject.model : null,
  } as BookingSearchState;
};

export const bookingSearchStorageSync: Serializer<BookingSearchState> = {
  deserialize: bookingSearchStorageDeserializer,
};
